<template>
  <div>
    <p class="email-text ml-9">{{ label }}</p>
    <div class="flex justify-between items-center ml-1 mr-1.5 mt-1">
      <div 
        class="mr-3"
        :class="disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'"
        @click="handleClick"
      >
        <img 
          v-if="isChecked" 
          src="@/assets/orderTest/Checkbox(all).svg" 
          alt="checked icon" 
          :class="['all-checked-box', disabled ? 'disabled-icon-img' : '']"
        >
        <span v-else :class="['material-icons-outlined', 'check-box', disabled ? 'disabled-icon' : '']">
          check_box_outline_blank
        </span>
      </div>
      <div class="w-11/12" @dblclick="handleDblClick">
        <el-tooltip 
          class="tooltip-email-edit" 
          effect="dark" 
          :content="$t('OrderPage[\'Please double click to edit\']')" 
          placement="bottom"
        >
          <el-input 
            v-if="isEdit"
            ref="notificationInput" 
            v-model="input"
            class="mr-3.5"
            @blur="handleBlur"
            @input="handleInput"
            @keyup.enter="handlePressEnter"
          >     
            <template v-slot:prefix>
              <span class="material-icons small-icon">{{ prefix }}</span>
            </template>       
          </el-input>
          <div
            v-else
            class="input-sub flex items-center"
          >     
            <span class="ml-2 material-icons small-icon">{{ prefix }}</span>
            <span class="ml-2 input-sub-text">{{ input }}</span>   
          </div>
        </el-tooltip>  
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["click", "dblClick", "blur", "input", "enterPressed"],
  props: {
    label: {
      type: String,
      default: ""
    },
    isSend: {
      type: Boolean,
      default: false
    },
    inputValue: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isChecked: false,
      input: "",
      isEdit: false,
      prevInput: ""
    }
  },

  watch: {
    isSend(newVal) {
      this.isChecked = newVal;
    },
    inputValue(newVal) {
      this.input = newVal;
    }
  },

  mounted() {
    this.isChecked = this.isSend;
    this.input = this.inputValue;
  },

  methods: {
    handleClick() {
      if (this.disabled) {
        return;
      }
      this.isChecked = !this.isChecked;
      this.$emit("click", this.isChecked);
    },
    handleDblClick() {
      this.isEdit = true;
      this.prevInput = this.input;
      this.$nextTick(() => {
        this.$refs.notificationInput.focus(); // focus the input
        this.$refs.notificationInput.select(); // select text in input
      });
    },
    handleBlur() {
      this.isEdit = false;
      this.$emit("blur", this.input);
      this.input = this.inputValue;
    },
    handleInput(value) {
      this.$emit("input", value);
    },
    handlePressEnter() {
      this.$emit("enterPressed", this.input);
      this.$refs.notificationInput.blur();
    }
  }
}
</script>

<style scoped>
.email-text {
  font-size: 12px;
  letter-spacing: 0.34px;
  line-height: 14px;
}

.all-checked-box {
  height: 20px;
  width: 20px;
  padding-bottom: 5px;
}

.check-box {
  font-size: 20px;
}
.disabled-icon {
  color: #BDBDBD;
}

.disabled-icon-img {
  filter: grayscale(100%);
  opacity: 0.6;
}

.small-icon {
  font-size: 18px;
}

.input-sub {
  box-sizing: border-box;
  height: 36px;
  padding-left: 2px;
  border: 1px solid #C9CACD;
  border-radius: 2px;
  box-shadow: none;
  
}

.input-sub-text {
  font-family: Roboto;
  font-size: 16px;
  color: #979797;
  letter-spacing: normal;
  line-height: 16px;
}
</style>